// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b19635ec","164":"a51e1403","199":"a9840213","236":"9b669e95","397":"28938ac4","416":"786aac2f","486":"251fd0f6","683":"682e6837","791":"07d6eb6f","892":"ad6707f3","956":"1498fce8"}[chunkId] + ".chunk.js";
};